import React from 'react';
import { useMutation } from '@apollo/client';
import EditTestMutation from './EditTestMutation';
import { HashimotoTestInputType } from '../types';
import TestsQuery from '../Fetch/TestsQuery';

interface IEditTest {
  editTest: {
    editMeasurement: (request: any) => Promise<any>;
    response: unknown;
    loading: boolean;
  };
}
interface IEditTestConnectorApollo {
  children: (editTest: IEditTest) => React.ReactElement;
}

const EditTestConnectorApollo: React.FC<IEditTestConnectorApollo> = ({ children }) => {
  const [editTest, { data, loading }] = useMutation(EditTestMutation);

  const createEditMeasurement = async (request: HashimotoTestInputType) => {
    const response = await editTest({
      variables: { request },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: TestsQuery,
        },
      ],
    });

    return response;
  };

  return children({
    editTest: {
      editMeasurement: createEditMeasurement,
      response: data,
      loading,
    },
  });
};

export default EditTestConnectorApollo;
